<template>
  <v-container fluid>
    <v-row>
      <v-col cols="12">
        <!-- Información del certificado -->
        <v-card :loading="cargando">
          <v-card-title class="d-flex align-center">
            <v-icon left class="mr-2">mdi-file-document</v-icon>
            Postulaciones {{getTipoLeyTexto(certificado.tipo)}} - {{ certificado.numero_certificado }}
            <v-spacer />
            <v-chip :color="getEstadoColor(certificado.estado)" dark class="mr-2">
              {{ getEstadoTexto(certificado.estado) }}
            </v-chip>
          </v-card-title>

          <v-card-text>
            <v-row>
              <v-col cols="12" md="6">
                <v-list dense>
                  <v-list-item>
                    <v-list-item-content>
                      <v-list-item-subtitle>Municipalidad</v-list-item-subtitle>
                      <v-list-item-title>{{ nombreMunicipalidad(certificado.municipalidad_id) || 'Cargando...' }}</v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>
                  <v-list-item>
                    <v-list-item-content>
                      <v-list-item-subtitle>Tipo de Ley</v-list-item-subtitle>
                      <v-list-item-title>
                        <v-chip small :color="getTipoLeyColor(certificado.tipo)">
                          {{ getTipoLeyTexto(certificado.tipo) }}
                        </v-chip>
                      </v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>
                  <v-list-item v-if="certificado.tramo">
                    <v-list-item-content>
                      <v-list-item-subtitle>Tramo</v-list-item-subtitle>
                      <v-list-item-title style="white-space: normal">
                        {{ getTramoTexto(certificado.tramo) }}
                      </v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>
                  <v-list-item>
                    <v-list-item-content>
                      <v-list-item-subtitle>Fecha de Creación</v-list-item-subtitle>
                      <v-list-item-title>{{ formatearFecha(certificado.fecha_creacion) }}</v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>
                  <v-list-item v-if="certificado.fecha_cerrado">
                    <v-list-item-content>
                      <v-list-item-subtitle>Fecha de Cierre</v-list-item-subtitle>
                      <v-list-item-title>{{ formatearFecha(certificado.fecha_cerrado) }}</v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>
                  <v-list-item v-if="certificado.fecha_enviado">
                    <v-list-item-content>
                      <v-list-item-subtitle>Fecha de Envío</v-list-item-subtitle>
                      <v-list-item-title>{{ formatearFecha(certificado.fecha_enviado) }}</v-list-item-title>
                    </v-list-item-content>
                    <v-list-item-action>
                      <v-btn
                        small
                        color="primary"
                        :loading="descargandoCertificadoEnvio"
                        @click="descargarCertificadoEnvio"
                      >
                        <v-icon left small>mdi-download</v-icon>
                        Certificado de Envío
                      </v-btn>
                    </v-list-item-action>
                  </v-list-item>
                </v-list>
              </v-col>
              <v-col cols="12" md="6">
                <v-list dense>
                  <v-list-item v-if="certificado.firmante_nombre">
                    <v-list-item-content>
                      <v-list-item-subtitle>Firmante</v-list-item-subtitle>
                      <v-list-item-title>{{ certificado.firmante_nombre }}</v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>
                  <v-list-item v-if="certificado.firmante_rut">
                    <v-list-item-content>
                      <v-list-item-subtitle>RUT Firmante</v-list-item-subtitle>
                      <v-list-item-title>{{ certificado.firmante_rut }}</v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>
                  <v-list-item v-if="certificado.firmante_cargo">
                    <v-list-item-content>
                      <v-list-item-subtitle>Cargo Firmante</v-list-item-subtitle>
                      <v-list-item-title>{{ certificado.firmante_cargo }}</v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>
                  <v-list-item v-if="certificado.observaciones">
                    <v-list-item-content>
                      <v-list-item-subtitle>Observaciones</v-list-item-subtitle>
                      <v-list-item-title>{{ certificado.observaciones }}</v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>
                </v-list>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>

        <v-card v-if="certificado.estado === 'enviado' && $auth.can(['gestor-subdere-incentivo-retiro'])" class="mt-4" :loading="cargando">
          <v-card-text>
            <!-- ENVIADO: Observar Proceso (solo SUBDERE) -->
              <v-btn
                v-if="certificado.estado === 'enviado' && $auth.can(['gestor-subdere-incentivo-retiro'])"
                color="orange"
                dark
                @click="dialogObservarProceso = true"
              >
                <v-icon left>mdi-eye-alert</v-icon>
                Observar Proceso
              </v-btn>
          </v-card-text>
        </v-card>


        <!-- Tabla de postulaciones -->
        <v-card class="mt-4" :loading="cargando">
          <v-card-title class="d-flex align-center">
            <v-icon left class="mr-2">mdi-account-multiple</v-icon>
            Postulaciones ({{ postulaciones.length }})
            <v-spacer />
            <v-btn
              v-if="certificado.estado === 'borrador' && puedeEditar"
              color="primary"
              small
              :to="{ name: 'incentivos-retiro-postulacion-crear', params: { id: certificado.id } }"
            >
              <v-icon left>mdi-plus</v-icon>
              Agregar Postulación
            </v-btn>
          </v-card-title>

          <v-data-table
            :headers="headersPostulaciones"
            :items="postulaciones"
            :items-per-page="15"
            class="elevation-0"
          >
            <template #[`item.rut`]="{ item }">
              <strong>{{ item.rut }}</strong>
            </template>

            <template #[`item.nombres`]="{ item }">
              {{ item.nombres }} {{ item.apellido_paterno }} {{ item.apellido_materno }}
            </template>

            <template #[`item.edad`]="{ item }">
              {{ calcularEdad(item.fecha_nacimiento, item.fecha_fallecimiento) }} años
            </template>

            <template #[`item.estado`]="{ item }">
              <v-chip :color="getEstadoPostulacionColor(item.estado)" small dark>
                {{ getEstadoPostulacionTexto(item.estado) }}
              </v-chip>
            </template>

            <template #[`item.cumple_requisitos`]="{ item }">
              <v-chip
                v-if="item.cumple_requisitos === true"
                small
                color="success"
                dark
              >
                <v-icon small left>mdi-check</v-icon>
                Cumple
              </v-chip>
              <v-chip
                v-else-if="item.cumple_requisitos === false"
                small
                color="error"
                dark
              >
                <v-icon small left>mdi-close</v-icon>
                No cumple
              </v-chip>
              <v-chip v-else small color="grey" outlined>
                Sin evaluar
              </v-chip>
            </template>

            <template #[`item.acciones`]="{ item }">
              <!-- Editar (solo si certificado borrador y postulación borrador) -->
              <v-tooltip bottom :key="`edit-${item.id}-${item.estado}`">
                <template #activator="{ on }">
                  <v-btn
                    v-if="((item.estado === 'borrador' && certificado.estado === 'borrador') || item.estado === 'observada') && puedeEditar"
                    icon
                    small
                    color="primary"
                    v-on="on"
                    :to="{ name: 'incentivos-retiro-postulacion-editar', params: { id: certificado.id, postulacionId: item.id } }"
                  >
                    <v-icon small>mdi-pencil</v-icon>
                  </v-btn>
                </template>
                <span>Editar</span>
              </v-tooltip>

              <!-- Modificar (marcar para corrección, cuando certificado observado) -->
              <v-tooltip bottom :key="`modificar-${item.id}-${item.estado}-${certificado.estado}`" v-if="esSubdere">
                <template #activator="{ on }">
                  <v-btn
                    v-if="item.estado === 'enviada' && certificado.estado === 'observado' && $auth.can(['gestor-subdere-incentivo-retiro'])"
                    icon
                    small
                    color="orange"
                    dark
                    v-on="on"
                    @click="marcarComoObservada(item)"
                  >
                    <v-icon small>mdi-pencil-box-outline</v-icon>
                  </v-btn>
                </template>
                <span>Marcar para corrección</span>
              </v-tooltip>

              <!-- Descargar PDF (pendiente_firma, firmada, validada) -->
              <v-tooltip bottom :key="`pdf-${item.id}-${item.estado}-${tieneFirmantes}`">
                <template #activator="{ on }">
                  <v-btn
                    v-if="['pendiente_firma', 'firmada', 'enviada', 'validada', 'observada'].includes(item.estado) && tieneFirmantes"
                    icon
                    small
                    color="primary"
                    v-on="on"
                    @click="descargarPDFPostulacion(item)"
                  >
                    <v-icon small>mdi-file-pdf-box</v-icon>
                  </v-btn>
                </template>
                <span>Descargar PDF para Firma</span>
              </v-tooltip>

              <!-- Subir documento firmado (pendiente_firma) -->
              <v-tooltip bottom :key="`upload-${item.id}-${item.estado}-${tieneFirmantes}`">
                <template #activator="{ on }">
                  <v-btn
                    v-if="(item.estado === 'pendiente_firma' || item.estado === 'observada') && puedeEditar && tieneFirmantes"
                    icon
                    small
                    color="orange"
                    dark
                    v-on="on"
                    @click="abrirDialogoSubirFirmado(item)"
                  >
                    <v-icon small>mdi-upload</v-icon>
                  </v-btn>
                </template>
                <span>Subir Postulación Firmada</span>
              </v-tooltip>

              <!-- Ver documento firmado (firmada, validada) -->
              <v-tooltip bottom :key="`view-${item.id}-${item.estado}`">
                <template #activator="{ on }">
                  <v-btn
                    v-if="item.archivo_postulacion_firmada_url && ['firmada', 'enviada', 'validada', 'observada'].includes(item.estado)"
                    icon
                    small
                    color="success"
                    v-on="on"
                    @click="descargarArchivoPostulacion(item.id, 'documento_firmado')"
                  >
                    <v-icon small>mdi-file-check</v-icon>
                  </v-btn>
                </template>
                <span>Ver Postulación Firmada</span>
              </v-tooltip>

              <!-- Eliminar (solo si certificado y postulación en borrador) -->
              <v-tooltip bottom :key="`delete-${item.id}-${item.estado}`">
                <template #activator="{ on }">
                  <v-btn
                    v-if="certificado.estado === 'borrador' && item.estado === 'borrador' && puedeEditar"
                    icon
                    small
                    color="error"
                    v-on="on"
                    @click="confirmarEliminarPostulacion(item)"
                  >
                    <v-icon small>mdi-delete</v-icon>
                  </v-btn>
                </template>
                <span>Eliminar</span>
              </v-tooltip>
            </template>
          </v-data-table>
        </v-card>

        <v-card class="mt-4" :loading="cargando">
          <v-card-text>
          <!-- Datos de Firmantes (en carga_cerrada y postulaciones_completas) -->
            <template v-if="['carga_cerrada', 'postulaciones_completas'].includes(certificado.estado) && puedeEditar">
              <v-subheader class="px-0">
                <v-icon left>mdi-account-multiple</v-icon>
                Datos de los Firmantes Municipales
              </v-subheader>

              <!-- Alerta informativa en carga_cerrada -->
              <v-alert v-if="certificado.estado === 'carga_cerrada'" type="info" text dense class="mb-3">
                <v-icon left small>mdi-information</v-icon>
                Los datos de los firmantes municipales deben ingresarse en este paso, ya que aparecerán en los PDFs de Postulaciones Individuales que descargarán los funcionarios.
              </v-alert>

              <!-- Mostrar datos si existen -->
              <v-row v-if="tieneFirmantes">
                <v-col cols="12" md="6">
                  <v-card outlined>
                    <v-card-subtitle class="pb-1">Firmante 1: Secretario Municipal</v-card-subtitle>
                    <v-card-text>
                      <p><strong>Nombre:</strong> {{ certificado.firmante1_nombre }}</p>
                      <p><strong>RUT:</strong> {{ certificado.firmante1_rut }}</p>
                      <p><strong>Cargo:</strong> {{ certificado.firmante1_cargo }}</p>
                    </v-card-text>
                  </v-card>
                </v-col>
                <v-col cols="12" md="6">
                  <v-card outlined>
                    <v-card-subtitle class="pb-1">Firmante 2: Director DAF/RRHH</v-card-subtitle>
                    <v-card-text>
                      <p><strong>Nombre:</strong> {{ certificado.firmante2_nombre }}</p>
                      <p><strong>RUT:</strong> {{ certificado.firmante2_rut }}</p>
                      <p><strong>Cargo:</strong> {{ certificado.firmante2_cargo }}</p>
                    </v-card-text>
                  </v-card>
                </v-col>
              </v-row>

              <!-- Botón para abrir modal -->
              <v-row>
                <v-col cols="12">
                  <v-btn
                    color="primary"
                    @click="dialogFirmantes = true"
                  >
                    <v-icon left>mdi-account-edit</v-icon>
                    {{ tieneFirmantes ? 'Editar' : 'Agregar' }} Datos de Firmantes
                  </v-btn>
                </v-col>
              </v-row>
            </template>

            <!-- Acciones según estado -->
            <v-divider class="my-4" />
            
            <!-- BORRADOR: Cerrar Carga de Postulaciones -->
            <v-alert v-if="certificado.estado === 'borrador'" type="info" dense text class="mb-3">
              <v-icon left small>mdi-information</v-icon>
              <strong>Paso 1:</strong> Agregue todas las postulaciones y luego cierre la carga para que los funcionarios firmen.
            </v-alert>
            
            <!-- CARGA_CERRADA: Esperando firmas -->
            <v-alert v-if="certificado.estado === 'carga_cerrada'" type="warning" dense text class="mb-3">
              <v-icon left small>mdi-clock-alert</v-icon>
              <strong>Paso 2:</strong> Ingrese los datos de los firmantes municipales y espere que todos los funcionarios suban sus postulaciones firmadas.
              {{ postulacionesFirmadas.length }}/{{ certificado.postulaciones.length }} completadas.
            </v-alert>
            
            <!-- POSTULACIONES_COMPLETAS: Generar certificado -->
            <v-alert v-if="certificado.estado === 'postulaciones_completas'" type="info" dense text class="mb-3">
              <v-icon left small>mdi-check-circle</v-icon>
              <strong>Paso 3:</strong> Todas las postulaciones están firmadas. Complete los datos del firmante y genere el certificado.
            </v-alert>
            
            <!-- PENDIENTE_ENVIO: Subir documentos -->
            <v-alert v-if="certificado.estado === 'pendiente_envio'" type="warning" dense text class="mb-3">
              <v-icon left small>mdi-upload</v-icon>
              <strong>Paso 4:</strong> Suba el Certificado de Cumplimiento firmado y el Decreto Alcaldicio para enviar a Subdere.
            </v-alert>

            <!-- OBSERVADO: Banner con observaciones de SUBDERE -->
            <v-alert v-if="certificado.estado === 'observado'" type="warning" prominent class="mb-3">
              <div class="text-subtitle-1 font-weight-bold mb-1">
                <v-icon left>mdi-eye-alert</v-icon>
                Certificado Observado por SUBDERE
              </div>
              <div>{{ certificado.observaciones }}</div>
              <div class="mt-2 text-caption" v-if="esSubdere">
                Marque las postulaciones que requieren corrección con el botón "Modificar", edite los datos necesarios, y luego finalice el proceso para reenviar.
              </div>
              <div v-if="$auth.can(['gestor-municipalidad-incentivo-retiro'])" class="mt-2 text-caption">
                Revise las observaciones realizadas por SUBDERE, corrija los datos del formulario de las postulaciones indicadas, y reenvíe el certificado.
              </div>
            </v-alert>

            <div class="d-flex justify-end flex-wrap" style="gap: 8px;">
              <!-- BORRADOR: Cerrar Carga de Postulaciones -->
              <v-btn
                v-if="certificado.estado === 'borrador' && puedeEditar"
                color="primary"
                :loading="cerrandoCarga"
                :disabled="!certificado.postulaciones || certificado.postulaciones.length === 0"
                @click="confirmarCerrarCarga"
              >
                <v-icon left>mdi-lock-check</v-icon>
                Cerrar Carga de Postulaciones
              </v-btn>

              <!-- POSTULACIONES_COMPLETAS: Borrador y Finalizar -->
              <v-btn
                v-if="['postulaciones_completas', 'observado'].includes(certificado.estado) && puedeEditar"
                color="info"
                :loading="generandoBorrador"
                @click="descargarBorrador"
              >
                <v-icon left>mdi-file-eye</v-icon>
                Borrador de Certificado
              </v-btn>
              <v-btn
                v-if="['postulaciones_completas', 'observado'].includes(certificado.estado) && puedeEditar"
                color="success"
                :loading="finalizandoProceso"
                :disabled="!puedeFinalizarProceso"
                @click="confirmarFinalizarProceso"
              >
                <v-icon left>mdi-check-bold</v-icon>
                Finalizar Proceso
                <span v-if="certificado.estado === 'observado'"> de observación de postulaciones</span>
              </v-btn>

              <!-- PENDIENTE_ENVIO: Descargar certificado y subir documentos -->
              <v-btn
                v-if="certificado.estado === 'pendiente_envio' && puedeEditar"
                color="primary"
                @click="descargarCertificadoFinal"
              >
                <v-icon left>mdi-download</v-icon>
                Descargar Certificado
              </v-btn>
              <v-btn
                v-if="certificado.estado === 'pendiente_envio' && puedeEditar"
                color="orange"
                dark
                @click="dialogSubirDocumentos = true"
              >
                <v-icon left>mdi-upload</v-icon>
                Subir Documentos
              </v-btn>
              <v-btn
                v-if="certificado.estado === 'pendiente_envio' && puedeEditar"
                color="success"
                :loading="enviando"
                :disabled="!certificado.certificado_cumplimiento_firmado_url || !certificado.decreto_alcaldicio_url"
                @click="confirmarEnviar"
              >
                <v-icon left>mdi-send</v-icon>
                Enviar a Subdere
              </v-btn>

              <!-- ENVIADO: Info -->
              <v-alert v-if="certificado.estado === 'enviado'" type="success" dense text class="mb-0">
                <v-icon left small>mdi-check-circle</v-icon>
                Certificado enviado a Subdere. No se pueden realizar más modificaciones.
              </v-alert>
            </div>

            <!-- Documentos adjuntos (si existen) -->
            <template v-if="certificado.certificado_cumplimiento_firmado_url || certificado.decreto_alcaldicio_url">
              <v-divider class="my-4" />
              <v-subheader class="px-0">Documentos Adjuntos</v-subheader>
              <v-list dense>
                <v-list-item v-if="certificado.certificado_cumplimiento_firmado_url">
                  <v-list-item-icon>
                    <v-icon color="success">mdi-file-pdf-box</v-icon>
                  </v-list-item-icon>
                  <v-list-item-content>
                    <v-list-item-title>Certificado de Cumplimiento Firmado</v-list-item-title>
                  </v-list-item-content>
                  <v-list-item-action>
                    <v-btn
                      icon
                      small
                      color="primary"
                      @click="descargarArchivo('certificado_cumplimiento')"
                    >
                      <v-icon small>mdi-download</v-icon>
                    </v-btn>
                  </v-list-item-action>
                </v-list-item>
                <v-list-item v-if="certificado.decreto_alcaldicio_url">
                  <v-list-item-icon>
                    <v-icon color="success">mdi-file-pdf-box</v-icon>
                  </v-list-item-icon>
                  <v-list-item-content>
                    <v-list-item-title>Decreto Alcaldicio</v-list-item-title>
                  </v-list-item-content>
                  <v-list-item-action>
                    <v-btn
                      icon
                      small
                      color="primary"
                      @click="descargarArchivo('decreto')"
                    >
                      <v-icon small>mdi-download</v-icon>
                    </v-btn>
                  </v-list-item-action>
                </v-list-item>
              </v-list>
            </template>
          </v-card-text>
        </v-card>

        <!-- Botón volver -->
        <div class="mt-4">
          <v-btn text @click="$router.push({ name: 'incentivos-retiro-certificados' })">
            <v-icon left>mdi-arrow-left</v-icon>
            Volver al listado
          </v-btn>
        </div>
      </v-col>
    </v-row>

    <!-- Dialog: Cerrar Carga de Postulaciones -->
    <v-dialog v-model="dialogCerrarCarga" max-width="600">
      <v-card>
        <v-card-title>Cerrar Carga de Postulaciones</v-card-title>
        <v-card-text>
          <v-alert type="warning" text>
            ¿Está seguro que desea cerrar la carga de postulaciones?
          </v-alert>
          <v-alert type="info" dense text class="mt-3">
            <strong>💡 ¿Qué sucederá?</strong>
            <ul class="mt-2">
              <li>Se bloquearán las postulaciones (no podrá agregar, editar ni eliminar)</li>
              <li>Podrá descargar los PDF de cada postulación para que sean firmados</li>
              <li>Deberá subir cada postulación firmada antes de continuar</li>
            </ul>
          </v-alert>
          <p class="mt-3"><strong>Total de postulaciones:</strong> {{ certificado.postulaciones ? certificado.postulaciones.length : 0 }}</p>
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn text @click="dialogCerrarCarga = false">Cancelar</v-btn>
          <v-btn color="primary" :loading="cerrandoCarga" @click="cerrarCargaPostulaciones">Confirmar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Dialog: Finalizar Proceso -->
    <v-dialog v-model="dialogFinalizarProceso" max-width="600">
      <v-card>
        <v-card-title>Finalizar Proceso</v-card-title>
        <v-card-text>
          <v-alert type="info" text>
            ¿Confirma que desea generar el Certificado de Cumplimiento?
          </v-alert>
          <v-alert type="warning" dense text class="mt-3">
            <strong>💡 ¿Qué sucederá?</strong>
            <ul class="mt-2">
              <li>Se generará el Certificado de Cumplimiento oficial (sin marca de agua)</li>
              <li>Ya no podrá modificar datos del firmante ni evaluaciones de cumplimiento</li>
              <li>Podrá descargar el certificado para firma del alcalde</li>
            </ul>
          </v-alert>
          <p class="mt-3">Verifique que todos los datos del firmante sean correctos y que haya marcado el cumplimiento de requisitos en todas las postulaciones.</p>
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn text @click="dialogFinalizarProceso = false">Cancelar</v-btn>
          <v-btn color="success" :loading="finalizandoProceso" @click="finalizarProceso">Confirmar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Dialog: Enviar a Subdere -->
    <v-dialog v-model="dialogEnviar" max-width="500">
      <v-card>
        <v-card-title>Enviar Certificado a Subdere</v-card-title>
        <v-card-text>
          <v-alert type="info" text>
            ¿Está seguro que desea enviar este certificado a Subdere?
          </v-alert>
          <v-alert type="warning" dense text class="mt-3">
            <strong>💡 ¿Qué sucederá?</strong>
            <ul class="mt-2">
              <li>El certificado se marcará como enviado oficialmente</li>
              <li>Ya no podrá realizar ninguna modificación</li>
              <li>Solo podrá consultar y descargar documentos</li>
            </ul>
          </v-alert>
          <p class="mt-3"><strong>Documentos adjuntos:</strong></p>
          <ul>
            <li>✓ Certificado de Cumplimiento Firmado</li>
            <li>✓ Decreto Alcaldicio</li>
          </ul>
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn text @click="dialogEnviar = false">Cancelar</v-btn>
          <v-btn color="primary" :loading="enviando" @click="enviarCertificado">Confirmar Envío</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Dialog: Subir documento firmado (postulación) -->
    <v-dialog v-model="dialogSubirFirmado" max-width="600">
      <v-card>
        <v-card-title>Subir Documento Firmado</v-card-title>
        <v-card-text>
          <p><strong>Funcionario:</strong> {{ postulacionSeleccionada.nombre_completo }}</p>
          <p><strong>RUT:</strong> {{ postulacionSeleccionada.rut }}</p>
          <v-file-input
            v-model="archivoFirmado"
            label="Documento Firmado (PDF)"
            accept="application/pdf"
            outlined
            prepend-icon="mdi-file-pdf-box"
            :rules="[v => !!v || 'El archivo es requerido']"
          />
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn text @click="dialogSubirFirmado = false">Cancelar</v-btn>
          <v-btn color="primary" :loading="subiendoFirmado" @click="subirDocumentoFirmado">Subir</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Dialog: Subir documentos del certificado -->
    <v-dialog v-model="dialogSubirDocumentos" max-width="700">
      <v-card>
        <v-card-title>Subir Documentos del Certificado</v-card-title>
        <v-card-text>
          <v-alert type="info" dense text class="mb-4">
            Suba el Certificado de Cumplimiento firmado por el alcalde y el Decreto Alcaldicio.
          </v-alert>
          <v-file-input
            v-model="archivoCertificadoFirmado"
            label="Certificado de Cumplimiento Firmado (PDF)"
            accept="application/pdf"
            outlined
            prepend-icon="mdi-file-certificate"
            hint="Certificado generado por el sistema y firmado por el alcalde"
            persistent-hint
            class="mb-4"
          />
          <v-file-input
            v-model="archivoDecretoAlcaldicio"
            label="Decreto Alcaldicio (PDF)"
            accept="application/pdf"
            outlined
            prepend-icon="mdi-file-document"
            hint="Decreto que autoriza/aprueba las postulaciones"
            persistent-hint
          />
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn text @click="dialogSubirDocumentos = false">Cancelar</v-btn>
          <v-btn
            color="primary"
            :loading="subiendoDocumentos"
            :disabled="!archivoCertificadoFirmado && !archivoDecretoAlcaldicio"
            @click="subirDocumentosCertificado"
          >
            Subir Documentos
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Diálogo Observar Proceso -->
    <v-dialog v-model="dialogObservarProceso" max-width="600">
      <v-card>
        <v-card-title>Observar Proceso</v-card-title>
        <v-card-text>
          <v-alert type="info" dense text class="mb-4">
            El certificado será devuelto para corrección. Ingrese las observaciones para la municipalidad.
          </v-alert>
          <v-textarea
            v-model="observacionesProceso"
            label="Observaciones"
            outlined
            rows="4"
            counter="2000"
            :rules="[v => !!v || 'Las observaciones son obligatorias', v => (v && v.length <= 2000) || 'Máximo 2000 caracteres']"
          />
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn text @click="dialogObservarProceso = false">Cancelar</v-btn>
          <v-btn
            color="orange"
            dark
            :loading="observandoProceso"
            :disabled="!observacionesProceso || observacionesProceso.length === 0"
            @click="observarProceso"
          >
            Confirmar Observación
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Modal de Firmantes -->
    <modal-firmantes
      v-model="dialogFirmantes"
      :certificado-id="certificadoId"
      :firmantes-actuales="{
        firmante1_nombre: certificado.firmante1_nombre,
        firmante1_rut: certificado.firmante1_rut,
        firmante1_cargo: certificado.firmante1_cargo,
        firmante1_subrogante: certificado.firmante1_subrogante,
        firmante2_nombre: certificado.firmante2_nombre,
        firmante2_rut: certificado.firmante2_rut,
        firmante2_cargo: certificado.firmante2_cargo,
        firmante2_subrogante: certificado.firmante2_subrogante,
      }"
      @guardar="guardarFirmantes"
    />

  </v-container>
</template>

<script>
import { apiClient } from '@/admin/services/API'
import { notificar, notificarErrorResponse } from '@/admin/utils/notificar'
import ModalFirmantes from '@/admin/components/ModalFirmantes.vue'

export default {
  name: 'IncentivosRetiroCertificadoDetalle',
  components: {
    ModalFirmantes,
  },
  data() {
    return {
      cargando: false,
      cerrandoCarga: false,
      generandoBorrador: false,
      descargandoCertificadoEnvio: false,
      finalizandoProceso: false,
      enviando: false,
      subiendoFirmado: false,
      subiendoDocumentos: false,
      certificado: {},
      postulaciones: [],
      dialogFirmantes: false,
      dialogCerrarCarga: false,
      dialogFinalizarProceso: false,
      dialogEnviar: false,
      dialogSubirFirmado: false,
      dialogSubirDocumentos: false,
      dialogObservarProceso: false,
      observacionesProceso: '',
      observandoProceso: false,
      postulacionSeleccionada: {},
      archivoFirmado: null,
      archivoCertificadoFirmado: null,
      archivoDecretoAlcaldicio: null,
      headersPostulaciones: [
        { text: 'RUT', value: 'rut' },
        { text: 'Nombre', value: 'nombres' },
        { text: 'Sector', value: 'sector' },
        { text: 'Edad', value: 'edad' },
        { text: 'Estado', value: 'estado' },
        { text: 'Cumple', value: 'cumple_requisitos' },
        { text: 'Acciones', value: 'acciones', sortable: false, align: 'center' },
      ],
    }
  },
  computed: {
    certificadoId() {
      return this.$route.params.id
    },
    puedeEditar() {
      return this.$auth.can(['gestor-municipalidad-incentivo-retiro', 'gestor-subdere-incentivo-retiro'])
    },
    esSubdere () {
      return this.$auth.can(['gestor-subdere-incentivo-retiro'])
    },
    postulacionesFirmadas() {
      if (!this.certificado.postulaciones) return []
      return this.certificado.postulaciones.filter(p => p.archivo_postulacion_firmada_url)
    },
    tieneFirmantes() {
      return !!(
        this.certificado.firmante1_nombre &&
        this.certificado.firmante1_rut &&
        this.certificado.firmante1_cargo &&
        this.certificado.firmante2_nombre &&
        this.certificado.firmante2_rut &&
        this.certificado.firmante2_cargo
      )
    },
    puedeFinalizarProceso() {
      // Solo requerir firmantes - cumple_requisitos se evalúa en Etapa 2 (Asignación)
      return this.tieneFirmantes
    },
  },
  mounted() {
    this.cargarCertificado()
  },
  methods: {
    nombreMunicipalidad(idMunicipalidad) {
      const municipalidad = this.payloadItemsMunicipalidades.find(m => m.value === +idMunicipalidad)
      return municipalidad !== undefined ? municipalidad.text : ''
    },
    async cargarCertificado() {
      try {
        this.cargando = true
        const { data } = await apiClient.get(`/tramites/incentivos-retiro/certificados/${this.$route.params.id}`)
        this.certificado = data.data
        this.postulaciones = data.data.postulaciones || []
      } catch (error) {
        notificarErrorResponse(error, 'Error al cargar el certificado')
        this.$router.push({ name: 'incentivos-retiro-certificados' })
      } finally {
        this.cargando = false
      }
    },
    
    async guardarFirmantes(formData) {
      try {
        await apiClient.put(`/tramites/incentivos-retiro/certificados/${this.certificado.id}/firmante`, formData)
        notificar({ message: 'Datos de los firmantes guardados correctamente', severity: 'success' })
        this.dialogFirmantes = false
        await this.cargarCertificado()
      } catch (error) {
        notificarErrorResponse(error, 'Error al guardar datos de los firmantes')
      }
    },

    confirmarCerrarCarga() {
      this.dialogCerrarCarga = true
    },

    async cerrarCargaPostulaciones() {
      try {
        this.cerrandoCarga = true
        await apiClient.post(`/tramites/incentivos-retiro/certificados/${this.certificado.id}/cerrar-carga`)
        notificar({ message: 'Carga de postulaciones cerrada. Los funcionarios pueden descargar y firmar sus PDFs.', severity: 'success' })
        this.dialogCerrarCarga = false
        await this.cargarCertificado()
      } catch (error) {
        notificarErrorResponse(error, 'Error al cerrar la carga')
      } finally {
        this.cerrandoCarga = false
      }
    },

    async descargarBorrador() {
      try {
        this.generandoBorrador = true
        const { data } = await apiClient.get(
          `/tramites/incentivos-retiro/certificados/${this.certificado.id}/borrador-certificado`,
          { responseType: 'blob' }
        )

        const blob = new Blob([data], { type: 'application/pdf' })
        const url = window.URL.createObjectURL(blob)
        const link = document.createElement('a')
        link.href = url
        link.download = `Borrador_Certificado_${this.certificado.numero_certificado}.pdf`
        link.click()
        window.URL.revokeObjectURL(url)

        notificar({
          message: 'Borrador descargado correctamente.',
          severity: 'success'
        })
      } catch (error) {
        notificarErrorResponse(error, 'Error al generar borrador')
      } finally {
        this.generandoBorrador = false
      }
    },

    async descargarCertificadoEnvio() {
      try {
        this.descargandoCertificadoEnvio = true
        const { data } = await apiClient.get(
          `/tramites/incentivos-retiro/certificados/${this.certificado.id}/certificado-envio`,
          { responseType: 'blob' }
        )

        const blob = new Blob([data], { type: 'application/pdf' })
        const url = window.URL.createObjectURL(blob)
        const link = document.createElement('a')
        link.href = url
        link.download = `Certificado_Envio_${this.certificado.numero_certificado}.pdf`
        link.click()
        window.URL.revokeObjectURL(url)

        notificar({
          message: 'Certificado de envío descargado correctamente.',
          severity: 'success'
        })
      } catch (error) {
        notificarErrorResponse(error, 'Error al descargar certificado de envío')
      } finally {
        this.descargandoCertificadoEnvio = false
      }
    },

    confirmarFinalizarProceso() {
      this.dialogFinalizarProceso = true
    },

    async finalizarProceso() {
      try {
        this.finalizandoProceso = true
        await apiClient.post(`/tramites/incentivos-retiro/certificados/${this.certificado.id}/finalizar-proceso`)
        notificar({ message: 'Proceso finalizado. Puede descargar el certificado para firma del alcalde.', severity: 'success' })
        this.dialogFinalizarProceso = false
        await this.cargarCertificado()
      } catch (error) {
        notificarErrorResponse(error, 'Error al finalizar el proceso')
      } finally {
        this.finalizandoProceso = false
      }
    },

    async descargarCertificadoFinal() {
      try {
        const { data } = await apiClient.get(
          `/tramites/incentivos-retiro/certificados/${this.certificado.id}/certificado-cumplimiento?borrador=false`,
          { responseType: 'blob' }
        )

        const blob = new Blob([data], { type: 'application/pdf' })
        const url = window.URL.createObjectURL(blob)
        const link = document.createElement('a')
        link.href = url
        link.download = `Certificado_Cumplimiento_${this.certificado.numero_certificado}.pdf`
        link.click()
        window.URL.revokeObjectURL(url)

        notificar({
          message: 'Certificado descargado. Súbalo firmado por el alcalde.',
          severity: 'success'
        })
      } catch (error) {
        notificarErrorResponse(error, 'Error al descargar certificado')
      }
    },

    confirmarEnviar() {
      this.dialogEnviar = true
    },

    async enviarCertificado() {
      try {
        this.enviando = true
        await apiClient.post(`/tramites/incentivos-retiro/certificados/${this.certificado.id}/enviar`)
        notificar({ message: 'Certificado enviado a Subdere correctamente', severity: 'success' })
        this.dialogEnviar = false
        await this.cargarCertificado()
      } catch (error) {
        notificarErrorResponse(error, 'Error al enviar el certificado')
      } finally {
        this.enviando = false
      }
    },

    async descargarPDFPostulacion(postulacion) {
      try {
        const { data } = await apiClient.get(
          `/tramites/incentivos-retiro/postulaciones/${postulacion.id}/descargar-pdf`,
          { responseType: 'blob' }
        )

        const blob = new Blob([data], { type: 'application/pdf' })
        const url = URL.createObjectURL(blob)
        const link = document.createElement('a')
        link.href = url
        link.download = `postulacion_${postulacion.rut}.pdf`
        link.click()
        URL.revokeObjectURL(url)

        notificar({ message: 'Documento descargado correctamente.', severity: 'success' })
      } catch (error) {
        notificarErrorResponse(error, 'Error al descargar documento')
      }
    },

    abrirDialogoSubirFirmado(postulacion) {
      this.postulacionSeleccionada = postulacion
      this.archivoFirmado = null
      this.dialogSubirFirmado = true
    },

    async subirDocumentoFirmado() {
      if (!this.archivoFirmado) {
        notificar({ message: 'Debe seleccionar un archivo', severity: 'error' })
        return
      }
      
      try {
        this.subiendoFirmado = true
        const formData = new FormData()
        formData.append('documento_firmado', this.archivoFirmado)
        
        await apiClient.post(
          `/tramites/incentivos-retiro/postulaciones/${this.postulacionSeleccionada.id}/marcar-firmada`,
          formData,
          {
            headers: { 'Content-Type': 'multipart/form-data' },
          }
        )
        
        notificar({ message: 'Documento firmado cargado correctamente', severity: 'success' })
        this.dialogSubirFirmado = false
        await this.cargarCertificado()
      } catch (error) {
        notificarErrorResponse(error, 'Error al subir documento')
      } finally {
        this.subiendoFirmado = false
      }
    },

    async subirDocumentosCertificado() {
      try {
        this.subiendoDocumentos = true
        const formData = new FormData()
        
        if (this.archivoCertificadoFirmado) {
          formData.append('certificado_cumplimiento_firmado', this.archivoCertificadoFirmado)
        }
        if (this.archivoDecretoAlcaldicio) {
          formData.append('decreto_alcaldicio', this.archivoDecretoAlcaldicio)
        }
        
        await apiClient.post(
          `/tramites/incentivos-retiro/certificados/${this.certificado.id}/documentos`,
          formData,
          {
            headers: { 'Content-Type': 'multipart/form-data' },
          }
        )
        
        notificar({ message: 'Documentos cargados correctamente', severity: 'success' })
        this.dialogSubirDocumentos = false
        this.archivoCertificadoFirmado = null
        this.archivoDecretoAlcaldicio = null
        await this.cargarCertificado()
      } catch (error) {
        if (error.response && error.response.status === 413) {
          notificar({ message: 'El archivo es demasiado grande', severity: 'error' })
        } else {
          notificarErrorResponse(error, 'Error al subir documentos')
        }
      } finally {
        this.subiendoDocumentos = false
      }
    },

    formatearFecha(fecha) {
      if (!fecha) return '-'
      try {
        const fechaObj = new Date(fecha)
        if (isNaN(fechaObj.getTime())) return '-'
        
        const day = String(fechaObj.getDate()).padStart(2, '0')
        const month = String(fechaObj.getMonth() + 1).padStart(2, '0')
        const year = fechaObj.getFullYear()
        const hours = String(fechaObj.getHours()).padStart(2, '0')
        const minutes = String(fechaObj.getMinutes()).padStart(2, '0')
        
        return `${day}/${month}/${year} ${hours}:${minutes}`
      } catch {
        return '-'
      }
    },

    calcularEdad(fechaNacimiento, fechaFallecimiento = null) {
      if (!fechaNacimiento || fechaNacimiento === "0000-00-00") return '-'
      const [year, month, day] = fechaNacimiento.split('T')[0].split('-').map(Number)
      const hoy = new Date()
      const nacimiento = new Date(year, month - 1, day)

      if (fechaFallecimiento && fechaFallecimiento !== "0000-00-00") {
        const [fYear, fMonth, fDay] = fechaFallecimiento.split('T')[0].split('-').map(Number)
        const fallecimiento = new Date(fYear, fMonth - 1, fDay)
        if (fallecimiento < hoy) {
          hoy.setTime(fallecimiento.getTime())
        }
      }

      let edad = hoy.getFullYear() - nacimiento.getFullYear()
      const mes = hoy.getMonth() - nacimiento.getMonth()
      if (mes < 0 || (mes === 0 && hoy.getDate() < nacimiento.getDate())) {
        edad--
      }
      return edad
    },

    getEstadoColor(estado) {
      return {
        borrador: 'grey',
        carga_cerrada: 'orange',
        postulaciones_completas: 'info',
        pendiente_envio: 'warning',
        enviado: 'success',
        observado: 'red',
      }[estado] || 'grey'
    },

    getEstadoTexto(estado) {
      return {
        borrador: 'Borrador',
        carga_cerrada: 'Carga Cerrada',
        postulaciones_completas: 'Postulaciones Completas',
        pendiente_envio: 'Pendiente de Envío',
        enviado: 'Enviado',
        observado: 'Observado',
      }[estado] || estado
    },

    getEstadoPostulacionColor(estado) {
      return {
        borrador: 'grey',
        pendiente_firma: 'orange',
        firmada: 'info',
        enviada: 'deep-purple',
        validada: 'success',
        observada: 'red',
      }[estado] || 'grey'
    },

    getEstadoPostulacionTexto(estado) {
      return {
        borrador: 'Borrador',
        pendiente_firma: 'Pendiente de Firma',
        firmada: 'Firmada',
        enviada: 'Enviada a SUBDERE',
        validada: 'Validada',
        observada: 'Observada',
      }[estado] || estado
    },

    getTipoLeyColor(tipo) {
      return {
        ley_21135: 'primary',
        ley_21724_menor_75: 'info',
        ley_21724_mayor_75: 'warning',
      }[tipo] || 'grey'
    },

    getTipoLeyTexto(tipo) {
      return {
        ley_21135: 'Ley 21.135',
        ley_21724_menor_75: 'Ley 21.724 (Menor 75 años)',
        ley_21724_mayor_75: 'Ley 21.724 (Mayor 75 años)',
      }[tipo] || tipo
    },
    getTramoTexto (tramo) {
      return {
        1: 'Postulantes que cuenten con 75 o más años de edad acreditados al 30 de junio de 2026',
        2: 'Postulantes que cuenten con 75 o más años de edad entre 01 de julio al 31 de diciembre de 2026',
      }[tramo] || tramo
    },

    confirmarEliminarPostulacion(postulacion) {
      if (confirm(`¿Está seguro que desea eliminar la postulación de ${postulacion.nombre_completo}?`)) {
        this.eliminarPostulacion(postulacion)
      }
    },

    async observarProceso() {
      try {
        this.observandoProceso = true
        await apiClient.post(
          `/tramites/incentivos-retiro/certificados/${this.certificado.id}/observar`,
          { observaciones: this.observacionesProceso }
        )

        // Agrega observacion a cada postulacion
        if (this.certificado.postulaciones && this.certificado.postulaciones.length > 0) {
          this.certificado.postulaciones.forEach(async postulacion => {
            await apiClient.post(
              `/tramites/incentivos-retiro/asignacion/beneficiarios/${postulacion.id}/observaciones`,
              { texto: this.observacionesProceso }
            )
          })
        }

        this.dialogObservarProceso = false
        this.observacionesProceso = ''
        notificar({ message: 'Certificado observado exitosamente', severity: 'success' })
        await this.cargarCertificado()
      } catch (error) {
        notificarErrorResponse(error, 'Error al observar el certificado')
      } finally {
        this.observandoProceso = false
      }
    },

    async marcarComoObservada(postulacion) {
      if (!confirm(`¿Marcar la postulación de ${postulacion.nombre_completo || postulacion.rut} para corrección?`)) return
      try {
        await apiClient.post(
          `/tramites/incentivos-retiro/postulaciones/${postulacion.id}/marcar-observada`
        )
        notificar({ message: 'Postulación marcada para corrección', severity: 'success' })
        await this.cargarCertificado()
      } catch (error) {
        notificarErrorResponse(error, 'Error al marcar la postulación')
      }
    },

    async eliminarPostulacion(postulacion) {
      try {
        await apiClient.delete(`/tramites/incentivos-retiro/postulaciones/${postulacion.id}`)
        notificar({ message: 'Postulación eliminada correctamente', severity: 'success' })
        await this.cargarCertificado()
      } catch (error) {
        notificarErrorResponse(error, 'Error al eliminar la postulación')
      }
    },
    descargarArchivo(tipoArchivo) {
      const url = `/tramites/incentivos-retiro/certificados/${this.certificado.id}/archivo/${tipoArchivo}`
      this.$axios
        .get(url, { responseType: 'blob' })
        .then((res) => {
          const blob = new Blob([res.data], { type: res.headers['content-type'] })
          const link = document.createElement('a')
          link.href = URL.createObjectURL(blob)
          link.download = url.split('/').pop()
          link.click()
          this.$emit('notificar', 'Descarga exitosa.')
        })
        .catch((error) => {
          console.log(error)
          this.$emit('notificar:error', 'El archivo seleccionado no se encuentra disponible.')
        })
    },
    descargarArchivoPostulacion(postulacionId, tipoArchivo) {
      const url = `/tramites/incentivos-retiro/postulaciones/${postulacionId}/archivo/${tipoArchivo}`
      this.$axios
        .get(url, { responseType: 'blob' })
        .then((res) => {
          const blob = new Blob([res.data], { type: res.headers['content-type'] })
          const link = document.createElement('a')
          link.href = URL.createObjectURL(blob)
          link.download = url.split('/').pop()
          link.click()
          this.$emit('notificar', 'Descarga exitosa.')
        })
        .catch((error) => {
          console.log(error)
          this.$emit('notificar:error', 'El archivo seleccionado no se encuentra disponible.')
        })
    }
  },
}
</script>
